import React, {useContext, useMemo} from 'react';
import {PlayerContext} from "../../../shared/contexts/playerContext";
import dayjs from "dayjs";
import LogTemplate from "../../logs/LogTemplate";
import {getMiracleBadgeLogColumns} from "../../logs/columns/miracleBadgeLogColumns";

const PlayerMiracleBadgeLog = () => {
    const { playerData } = useContext(PlayerContext);

    const defaultSearchParams = {
        begin: dayjs().subtract(3, 'month').startOf('day').unix(),
        end: dayjs().endOf('day').unix(),
        pid: playerData.pid,
        logType: 'RQMiracleBadgeLog',
        isUnix: true
    };

    const columns = useMemo(() => getMiracleBadgeLogColumns(), []);

    return (
        <div>
            <LogTemplate
                columns={columns}
                defaultSearchParams={defaultSearchParams}
                routerUrl={'/logs/operation'}
                logName={'MiracleBadgeLog'}
                log={'operation'}
            />
        </div>
    );
};

export default PlayerMiracleBadgeLog;
